export const actionTypes = {
  FETCH_PRODUCTS: 'FETCH_PRODUCTS',
};

export const mutationTypes = {
  SET_QUERY: 'SET_QUERY',
  SET_QUERY_LIST: 'SET_QUERY_LIST',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_IS_REFRESH: 'SET_IS_REFRESH',
  SET_IS_MESSAGE: 'SET_IS_MESSAGE',
  SET_FETCHED_ALL: 'SET_FETCHED_ALL',
  SET_IS_OPEN_POPUP: 'SET_IS_OPEN_POPUP',
  RESET_PRODUCT_DATA: 'RESET_PRODUCT_DATA',
  ADD_PICKED_PRODUCT: 'ADD_PICKED_PRODUCT',
  RESET_SEARCH_RESULT: 'RESET_SEARCH_RESULT',
  SET_SELECTOR_ELEMENT: 'SET_SELECTOR_ELEMENT',
  SET_FETCHED_ALL_QUERY: 'SET_FETCHED_ALL_QUERY',
  SET_PRODUCT_MODULE_ID: 'SET_PRODUCT_MODULE_ID',
};

export const getterTypes = {
  GET_QUERY: 'GET_QUERY',
  GET_QUERY_LIST: 'GET_QUERY_LIST',
  GET_IS_MESSAGE: 'GET_IS_MESSAGE',
  GET_IS_LOADING: 'GET_IS_LOADING',
  GET_IS_REFRESH: 'GET_IS_REFRESH',
  GET_IS_OPEN_POPUP: 'GET_IS_OPEN_POPUP',
  GET_PRODUCTS_LIST: 'GET_PRODUCTS_LIST',
  GET_SELECTER_ELEMENT: 'GET_SELECTER_ELEMENT',
  GET_CACHED_QUERY_LIST: 'GET_CACHED_QUERY_LIST',
  GET_FETCHED_ALL: 'GET_FETCHED_ALL',
  GET_FETCHED_ALL_QUERY: 'GET_FETCHED_ALL_QUERY',
  GET_PRODUCT_MODULE_ID: 'GET_PRODUCT_MODULE_ID',
};
